import { compileConditions, filterKindForColumnType, matchesFilter, } from './filters';
export const CONDITION_MATCHES = ['all', 'any'];
/**
 * Compiles a rule's conditions once, for a pass over many rows.
 *
 * Unlike the board filter, which drops a condition it cannot read, a rule
 * fails closed: one naming a column that is gone, or with no value, matches no
 * row. Dropped here, the rule would run on every row its trigger reaches, and a
 * condition decides which rows get written, not which get shown. A rule with
 * no conditions at all still runs on every row.
 */
export function compileRuleConditions(conditions, columns) {
    if (!conditions || conditions.rules.length === 0)
        return () => true;
    if (!conditionsAreReadable(conditions, columns))
        return () => false;
    const compiled = compileConditions(conditions.rules, conditionColumns(columns));
    const any = conditions.match === 'any';
    return (values, todayIso) => {
        const passes = (filter) => matchesFilter(values?.[filter.columnId], filter, todayIso);
        return any ? compiled.some(passes) : compiled.every(passes);
    };
}
/**
 * Whether the board can still read every one of a rule's conditions: each names
 * a column a condition can name and holds a value. A rule whose conditions are
 * not readable runs on no row.
 */
export function conditionsAreReadable(conditions, columns) {
    if (!conditions)
        return true;
    return (compileConditions(conditions.rules, conditionColumns(columns)).length ===
        conditions.rules.length);
}
/** Whether a row passes a rule's conditions; see {@link compileRuleConditions}. */
export function passesConditions(values, conditions, columns, todayIso) {
    return compileRuleConditions(conditions, columns)(values, todayIso);
}
/** The columns a condition can name: those the board's filter can filter by. */
export function conditionColumns(columns) {
    return columns.flatMap((column) => {
        const kind = filterKindForColumnType(column.type);
        return kind ? [{ id: column.id, kind }] : [];
    });
}
